// extracted by mini-css-extract-plugin
module.exports = {"notFoundWrapper":"NotFound_notFoundWrapper__zNCf_","errorWrapper":"NotFound_errorWrapper__PZetc","headlineWrapper":"NotFound_headlineWrapper__pHOvv"};